// Copyright (c) Docugami, Inc. All rights reserved.
export interface AssistedAuthoringSettings {
    currentModel: string;
    showWordTestTaskpane: boolean;
    contextMode: boolean;
}

export interface SettingsState {
    settingsPanelShowing: boolean;
    assistedAuthoring: AssistedAuthoringSettings;
}

export const SET_SETTINGS_PANEL_SHOWING = "SET_SETTINGS_PANEL_SHOWING";
export const SET_ASSISTED_AUTH_SETTINGS = "SET_ASSISTED_AUTH_SETTINGS";
export const SET_WORD_TEST_TASKPANE_SHOWING = "SET_WORD_TEST_TASKPANE_SHOWING";

interface SetAssistedAuthoringSettings {
    type: typeof SET_ASSISTED_AUTH_SETTINGS;
    payload: AssistedAuthoringSettings;
}

interface SetSettingsPanelShowing {
    type: typeof SET_SETTINGS_PANEL_SHOWING;
    payload: boolean;
}

interface SetWordTestTaskpaneShowing {
    type: typeof SET_WORD_TEST_TASKPANE_SHOWING;
    payload: boolean;
}

export type SettingsActionTypes =
    SetAssistedAuthoringSettings |
    SetWordTestTaskpaneShowing |
    SetSettingsPanelShowing;
